module.exports = __webpack_public_path__ + "static/img/AppStore.6abdfb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/footer/img/AppStore.svg
// module id = B3UF
// module chunks = 42